import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Application } from 'projects/Autofacets-Core/src/app/utils/enums';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { AutoKeyViewModel } from '../../../business-entities/auto-key-model';
import { BrandViewModel } from '../../../business-entities/brand-view-model';
import { UserDealersModel } from '../../../business-entities/dealer-details.model';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import { BrandService } from '../../../business-services/brand.service';
import { DealerSearchService } from '../../../business-services/dealer-serach.service';
import { DealerBusinessService } from '../../../business-services/dealer.service';
import { SettingService } from '../../../business-services/setting.service';
import { AutoKeyBusinessService } from './../../../business-services/auto-key.service';
import { AddAutoKeyComponent } from './add-auto-key/add-auto-key/add-auto-key.component';
import { ViewAutoKeyComponent } from './view-auto-key/view-auto-key/view-auto-key.component';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';

@Component({
  selector: 'app-auto-key',
  templateUrl: './auto-key.component.html',
  styleUrls: ['./auto-key.component.css']
})
export class AutoKeyComponent implements OnInit, OnDestroy {
  total$: Observable<number>;
  popupCloseResult = false;
  selectedDealerId: string = '';
  dealerSelected: string = '';
  paginationSub: Subscription;
  autoKeyDetails: AutoKeyViewModel[];
  activeReservationList: any[];
  dealerList: Array<SelectListItemViewModel>;
  userRoleRightsDetails: UserRoleMenu;
  isDealerLoggedIn: boolean;
  brandList: BrandViewModel[];
  activeTab:string = 'autokey';
  loadedTabs: { [key: string]: boolean } = {}; // Track which tabs have loaded data
  licensePlateClass:string;
  features:any
  shareBox:any

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    public pService: CustomPaggerService,
    public dealerBusinessService: DealerBusinessService,
    private spinner: NgxSpinnerService,
    private service: AutoKeyBusinessService,
    public settingService: SettingService,
    private userService: UserDataService,
    private globalSetting:GlobalSetting,
    private modalService: NgbModal,
    private toaster: ToastrService,
    private translate: TranslateService,
    private secureStorage: SecureStorage,
    private currentLanguageService: CurrentLanguage,
    config: NgbModalConfig
  ) {
    this.pService.pageSize = 15;
    this.pService.searchby = ['dealerName', 'workorderNumber', 'licensePlate'];
    this.pService.searchTerm = '';
    config.backdrop = 'static';
    config.keyboard = false;
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  ngOnInit(): void {
    //if sharebox is enable then only activereservationlist will be visible.
    this.features = this.secureStorage.getKeyData('feature');
    if (this.features == null || this.features == undefined) {
      this.currentLanguageService.featureList.subscribe((res) => {
        this.features = res;
        this.shareBox = this.features.find(x => x.featureCode === fromEnums.FeatureCode.ShareBox)?.isActive;
      })
    }
    this.shareBox = this.features.find(x => x.featureCode === fromEnums.FeatureCode.ShareBox)?.isActive; 
    this.licensePlateClass=this.globalSetting.getGlobalLicencePlate();
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === fromEnums.ModuleNames.AutoKey);
    this.isDealerLoggedIn = this.userService.currentUserValue.roleType === fromEnums.UserRoles.DealerAdmin;
    this.dealerSelected = this.userService.currentUserValue.defaultDealerId;
    this.selectedDealerId = this.userService.currentUserValue.defaultDealerId;
    this.getUserDealers();
    this.pService.dataSource = [];
    this.getAutoKeyDetails(this.selectedDealerId);
  }

  async GetActiveReservationList(dealerId: string){
    this.spinner.show();
    const activeReservationList = await this.service.GetActiveReservationList(dealerId); 
    if(activeReservationList.length>0&&activeReservationList!=null){
      this.activeReservationList = activeReservationList;
      this.spinner.hide();
    }
    else{
      this.activeReservationList = [];
      this.spinner.hide();
    }
  }
  async getUserDealers(){
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapdealer(response.userDealersModel);
      const sortedDealerList = this.dealerList.slice().sort((x, y) => x.text.localeCompare(y.text))
      this.dealerList = sortedDealerList;
      this.service.dealerList = this.dealerList;
      if(this.dealerList.length === 1){
        this.dealerSelected = this.dealerList[0].value;
      }
    })
  }

  mapdealer(array: UserDealersModel[]){
    let supperArray = [];
    if (array && array.length > 0) {

      array.forEach(element =>{
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName

        supperArray.push(single);
      })
    }
    return supperArray;
  }

  checkId() {
    if (this.service.isEdit && this.service.dealerId) {
      this.service.isEdit = false;
    }
    else {
      this.service.dealerId = '';
    }
  }

  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
  }

  
  async getAutoKeyDetails(dealerId) {
    this.spinner.show();
  
    let Id = dealerId ?? '';
    const response = await this.service.getAutoKeyDetailsByDealer(Id);
  
    if (!response.keyLocationViewModel) {
      this.pService.dataSource = [];
      this.spinner.hide();
      return;
    }
  
    this.pService.dataSource = response.keyLocationViewModel;
  
    if (response.keyLocationViewModel.length === 0) {
      this.spinner.hide();
      return;
    }
  
    this.paginationSub = this.pService.dealers$.subscribe(result => {
      this.autoKeyDetails = this.autoKeyDataMapper(result);
    });
  
    if (Id !== '') {
      this.dealerSelected = response.keyLocationViewModel[0].dealerName;
      let dealerId = this.userService.currentUserValue.dealerId;
  
      if (this.dealerList) {
        const selectedDealer = this.dealerList.find(x => x.text === this.dealerSelected);
        if (selectedDealer) {
          dealerId = selectedDealer.value;
        }
      }
  
      if (!this.selectedDealerId) {
        this.setDealerId(dealerId);
      }
    }
  
    this.spinner.hide();
  }

  setDealerId(dealerId: string) {
    this.selectedDealerId = dealerId;
  }

  onTabChange(tabId: string) {
    this.activeTab = tabId;
    if (!this.loadedTabs[this.activeTab]) {
      this.callAPIForActiveTab();
    }
  }
  
  onDealerSelected(dealerId: string) {
    if(dealerId!=null){
      this.service.dealerId = dealerId ?? null;
      this.selectedDealerId = dealerId;
      this.dealerSelected = this.dealerList.find(x => x.value === dealerId)?.text;
      this.setDealerId(this.service.dealerId);  
    } 
    else{
      this.service.dealerId = dealerId ?? null;
      this.selectedDealerId = dealerId;
      this.activeReservationList = [];
    }
    this.loadedTabs = {}; 
    this.callAPIForActiveTab();
  }
  
  callAPIForActiveTab() {
    if (this.activeTab === 'autoKey' && !this.loadedTabs['autoKey']) {
      this.getAutoKeyDetails(this.selectedDealerId);
      this.loadedTabs['autoKey'] = true;
    } else if (this.activeTab === 'activeReservationList' && !this.loadedTabs['activeReservationList']) {
      if(this.selectedDealerId!=null){
        this.GetActiveReservationList(this.selectedDealerId);
      }
      this.loadedTabs['activeReservationList'] = true;
    }
  }

  private autoKeyDataMapper(data: AutoKeyViewModel[]) {
    let supperArray = [];
    if (data && data.length > 0) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        const single = Object();
        single.rowNumber = this.currentPageNumber(index);
        single.id = element.id;
        single.appointmentId = element.appointmentId;
        single.licensePlate = element.licensePlate;
        single.model = element.model;
        single.workorderNumber = element.workorderNumber;
        single.status = element.status;
        single.brand = element.brand;
        single.customerName = element.customerName;
        single.dealerName = element.dealerName;
        single.mobile = element.mobile;
        single.lockerAssignDate = element.lockerAssignDate ? element.lockerAssignDate : null;
        single.pickUpDate = element.keyPickUpDate ? element.keyPickUpDate : null;
        single.lockerId = element.lockerId;
        single.WOStatusId = element.woStatusId;
        single.lockerName = element.lockerName;
        single.isKeyPickedUp= element.isKeyPickedUp;
        single.appointmentDate = element.appointmentDate ? element.appointmentDate  : null;
        single.sourceName=element.sourceName;
        single.kioskType=element.kioskType;
        single.kioskLocation=element.kioskLocationName;
        single.exchangeMethod = element.exchangeMethodName;
        single.kioskLockerName=element.kioskLockerName;
        single.appointmentType = element.appointmentType;
        single.cancelled = element.cancelled;
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  onAdd() {
    const modalref = this.modalService.open(AddAutoKeyComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  viewAutoKeyDeatils(autoKeyId: number) {
    this.service.autoKeyId = autoKeyId;
    const modalref = this.modalService.open(ViewAutoKeyComponent, { size: 'md', windowClass: 'EditPopup' });
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
      });
  }

  unlockAutoKey(autoKeyId : number)
  {
    this.spinner.show();
    this.service.unlockKeyLocker(autoKeyId,Application.Admin).then(res => {
      if (res) {
        if(res.responseObject === true)
        {
           let success = this.translate.instant("lblKeyLockerUnlocked");
          this.toaster.success(success);
          this.ngOnInit();
        }
        else if(res.responseObject===false){
          let error = this.translate.instant("lblKeyLockerUnlockedFailed");
          this.toaster.error(error);
        }
        else if(res.responseObject.errorCount >0 )
        {
          this.spinner.hide();
        }
      }
    })
    this.spinner.hide();
  }


  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    }
    else if (this.pService.page > 1) {
      rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
    }
    return rtPageNumber;
  }
  onRefreshClick(){
    if (this.activeTab === 'autoKey') {
      this.getAutoKeyDetails(this.selectedDealerId);
      this.loadedTabs['autoKey'] = true;
    } else if (this.activeTab === 'activeReservationList') {
      if(this.selectedDealerId!=null){
        this.GetActiveReservationList(this.selectedDealerId);
      }
      this.loadedTabs['activeReservationList'] = true;
    }
  }
}
